export enum Actions {
  VIEW_UPGRADE_MEMBERSHIP = "viewUpgradeMembership ",
  VIEW_PURCHASING_VALUE = "viewPurchasingValue",
  VIEW_CURRENT_VALUE = "viewCurrentValue",
  VIEW_VIRTUAL_PROFIT = "viewVirtualProfit",
  UPDATE_VISIBILITY = "updateVisibility",
  VIEW_FINANCIAL_DATA = "viewFinancialData",
  UPDATE_FINANCIAL_VISIBILITY = "updateFinancialVisibility",
  VIEW_NUMERIC_DATA = "viewNumericData",
  UPDATE_NUMERIC_VISIBILITY = "updateNumericVisibility",
  UPDATE_OPEN_OFFERS = "updateOpenOffers",
  VIEW_ITEM_VALUE = "viewItemCurrentValue",
  VIEW = "view",
  UPDATE = "update",
  DO = "do",
}

export enum Subjects {
  USER = "User",
  COLLECTOR = "Collector",
  COLLECTION = "Collection",
  STATS = "Stats",
  SHIRT = "Shirt",
  SHIRT_MODEL = "ShirtModel",
  TOP10 = "Top10",
  UPGRADE_MEMBERSHIP = "UpgradeMembership",
  PREMIUM_BADGE = "PremiumBadge",
  SIGN_UP_BUTTON = "SignUpButton",
  MENU = "Menu",
  MENU_MY_COLLECTION = "menu-myCollection",
  MENU_SALE_HISTORY = "menu-salesHistory",
  MENU_SHOP = "menu-store",
  MENU_SHIRTS_COLLECTIONS = "menu-shirts-collections",
  MENU_COMMUNITY = "menu-community",
  MENU_BLOG = "menu-blog",
  MENU_SEARCH_FOR_COLLECTORS = "search-for-collectors",
  COMMUNITY = "community",
  TOP_COLLECTORS = "topCollectors",
  LEGIT_CHECK = "LegitCheck",
}
